import { Button } from 'components'
import { PlusActions } from 'actions'

export default class InstallButton extends React.Component {
  static propTypes = {
    label: React.PropTypes.string.isRequired,
    buttonType: React.PropTypes.string.isRequired,
    currentUser: React.PropTypes.object.isRequired,
    status: React.PropTypes.object.isRequired,
    installNow: React.PropTypes.bool,
    disabled: React.PropTypes.bool,
    className: React.PropTypes.string,
  }

  componentDidMount() {
    this.props.installNow && this.install()
  }

  install() {
    const { installed, needsUpgrade } = this.props.status
    const isUpgrade = installed && needsUpgrade

    // Note: the 3rd param could be 'partial' or 'complete'. 'complete' is deprecated
    PlusActions.install(this.props.currentUser, isUpgrade, 'partial')
  }

  render() {
    return (
      <div>
        <Button
          label={this.props.label}
          buttonType={this.props.buttonType}
          onTouchTap={::this.install}
          className={this.props.className}
          disabled={this.props.disabled}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/InstallButton.js